import React from 'react';
export type StatusVariant = 'success' | 'warning' | 'danger' | 'neutral' | 'info';
interface StatusBadgeProps {
  status: string;
  variant?: StatusVariant; // If not provided, inferred from status text
  size?: 'sm' | 'md';
}
export function StatusBadge({
  status,
  variant,
  size = 'md'
}: StatusBadgeProps) {
  const getVariant = (s: string): StatusVariant => {
    if (variant) return variant;
    const lower = s.toLowerCase();
    if (['attivo', 'pagata', 'completata', 'idoneo', 'in regola', 'accettato', 'positivo'].some(k => lower.includes(k))) return 'success';
    if (['in scadenza', 'da fare', 'in valuta', 'in lavorazione', 'parzialmente'].some(k => lower.includes(k))) return 'warning';
    if (['scaduto', 'non attivo', 'non idoneo', 'non pagata', 'negativo', 'revocato', 'urgente'].some(k => lower.includes(k))) return 'danger';
    if (['prospect', 'da proporre', 'da contattare'].some(k => lower.includes(k))) return 'info';
    return 'neutral';
  };
  const finalVariant = getVariant(status);
  const styles = {
    success: 'bg-green-100 text-green-700 border-green-200',
    warning: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    danger: 'bg-red-100 text-red-700 border-red-200',
    neutral: 'bg-slate-100 text-slate-700 border-slate-200',
    info: 'bg-blue-100 text-blue-700 border-blue-200'
  };
  const sizes = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-2.5 py-1 text-xs'
  };
  return <span className={`
      inline-flex items-center justify-center font-semibold rounded-full border 
      ${styles[finalVariant]} 
      ${sizes[size]}
    `} data-id="element-529">
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 
        ${finalVariant === 'success' ? 'bg-green-500' : finalVariant === 'warning' ? 'bg-yellow-500' : finalVariant === 'danger' ? 'bg-red-500' : finalVariant === 'info' ? 'bg-blue-500' : 'bg-slate-500'}
      `} data-id="element-530"></span>
      {status}
    </span>;
}